import { render, staticRenderFns } from "./Precommande.vue?vue&type=template&id=05ad20b8&"
import script from "./Precommande.vue?vue&type=script&lang=js&"
export * from "./Precommande.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports